module.exports = __webpack_public_path__ + "static/media/20200731-145149-001.d4810a18.png";